<template>
    <v-app>
        <sideMenu :drawer="drawer" @input="drawer = $event"></sideMenu>
        <headerBar :drawer="drawer" @input="drawer = $event"></headerBar>
        <v-main>
            <router-view />
        </v-main>
    </v-app>
</template>

<script>
import headerBar from '@/components/common/headerBar.vue'
import sideMenu from '@/components/common/sidemenu.vue'
export default {
    name: "App",
    components: {
        headerBar,
        sideMenu
    },
    data: () => ({
        drawer: null,
    }),
};
</script>
